import { COLOR_PALETTE } from "@/constants/color-palette"

export const TAG_COLOR_PALETTE = COLOR_PALETTE

export function getDefaultTagColor(tag: string): string {
  let hash = 0
  for (let i = 0; i < tag.length; i++) {
    hash = (hash << 5) - hash + tag.charCodeAt(i)
    hash |= 0
  }
  return COLOR_PALETTE[Math.abs(hash) % COLOR_PALETTE.length]
}
